import _ from 'lodash'

export default ({ items }) => (index) =>
  42 + // a few seconds ago
  4 * 28 + // static readings
  _.get(items[index], 'item.readings.length', 0) * 28 + // dynamic readings
  22 + // raw json button
  20 * 2 + // inner padding
  20 // top padding
